import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Guide.module.css'

function Cards({image,title,alternate,descrip,guidePage}) {
    return (
        <>
            <Link to={guidePage} className={styles.guideLink}>
                <div className={styles.guide}>
                    <img src={image} alt={alternate}/>
                    <h1>{title}</h1><br/>
                    <p>{descrip}</p>
                </div>
            </Link>
        </>
    )
}

export default Cards
